var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTE5IDYuNDEtMS40MS0xLjQxLTUuNTkgNS41OS01LjU5LTUuNTktMS40MSAxLjQxIDUuNTkgNS41OS01LjU5IDUuNTkgMS40MSAxLjQxIDUuNTktNS41OSA1LjU5IDUuNTkgMS40MS0xLjQxLTUuNTktNS41OXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01IC01KSIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+Cg==";
export { SvgIconClose as ReactComponent };